<div class="e-resource" *ngIf="event.billingContactName">
  <div class="e-icons">
    <nz-icon nzType="calendar" nzTheme="outline" class="e-custom-icon" />
  </div>
  <div class="e-resource-details e-text-ellipsis">
    {{ event.StartTime | moment: 'HH:mm' }} -
    {{ event.EndTime | moment: 'HH:mm' }}
  </div>
</div>
<div class="e-resource" *ngIf="event.billingContactName">
  <div class="e-icons">
    <nz-icon nzType="audit" nzTheme="outline" class="e-custom-icon" />
  </div>
  <div class="e-resource-details e-text-ellipsis">
    <ng-container *ngIf="event.customerCompanyName?.length > 2"
      >{{ event.customerCompanyName }} -</ng-container
    >
    {{ event.billingContactName }}
  </div>
</div>
<div class="e-resource" *ngIf="event.deliveryName">
  <div class="e-icons">
    <nz-icon nzType="file-done" nzTheme="outline" class="e-custom-icon" />
  </div>
  <div class="e-resource-details e-text-ellipsis">
    {{ event.deliveryName }}: {{ event.deliveryEmail }}
    {{ event.deliveryPhoneLandline }}
    {{ event.deliveryPhoneMobile }}
  </div>
</div>
<div class="e-resource" *ngIf="event.projectStatus || event.financialStatus">
  <div class="e-icons">
    <nz-icon
      nzType="fund-projection-screen"
      nzTheme="outline"
      class="e-custom-icon"
    />
  </div>
  <div class="e-resource-details e-text-ellipsis">
    <ng-container *ngIf="event.projectStatus">{{
      event.projectStatus
    }}</ng-container>
    <ng-container *ngIf="event.financialStatus">
      - {{ event.financialStatus }}</ng-container
    >
  </div>
</div>
<div class="e-resource">
  <div class="e-icons">
    <nz-icon
      nzType="link"
      nzTheme="outline"
      class="e-custom-icon"
      *ngIf="event.type != 'custom'"
    />
  </div>
  <div class="e-resource-details e-text-ellipsis">
    <ng-container *ngIf="event.type === 'custom'">Custom event</ng-container>
    <a
      [routerLink]="['/' + InombraRoutes.Cart, event.cart]"
      *ngIf="event.type === 'cart'"
      >Cart: {{ event.cart }}</a
    >
    <a
      [routerLink]="['/' + InombraRoutes.Workflow, event.workflow]"
      *ngIf="event.type === 'workflow'"
      >Workflow: {{ event.workflow }}</a
    >
    <a
      [routerLink]="['/' + InombraRoutes.Account, event.account]"
      *ngIf="event.type === 'account'"
      >Account: {{ event.account }}</a
    >
  </div>
</div>

<div class="e-resource">
  <div class="e-icons">
    <nz-icon nzType="setting" nzTheme="outline" class="e-custom-icon" />
  </div>
  <div class="e-resource-details e-text-ellipsis">
    {{ event.TechnicianNames }}
  </div>
</div>
<div class="e-resource">
  <div class="e-icons">
    <nz-icon nzType="environment" nzTheme="outline" class="e-custom-icon" />
  </div>
  <div class="e-text-ellipsis">
    <a
      href="https://maps.google.com/?q={{ this.utils.formatAddress(event) }}"
      target="_blank"
    >
      {{ this.utils.formatAddress(event) }}
    </a>
  </div>
</div>
